module.exports = "https://coursera_assets.s3.amazonaws.com/images/6a425d86738783570d711e6ef889cb5e.png";